// action types for product slice is declared here

export const ADD_PRODUCT = 'product/addProduct';
export const INCREASE_STOCK = 'product/increaseStock';
export const DECREASE_STOCK = 'product/decreaseStock';